module.exports = __webpack_public_path__ + "static/media/checkingin-logo-yellow-teal.f9d14daa.png";